import { useContext, useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';

import background from 'assets/Resc_Office.png';

import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { useAccount, useMsal } from '@azure/msal-react';
import { ColorContext } from 'App';
import msLogo from 'assets/microsoftlogo.png';
import { CustomInput } from 'components/UI/CustomInput';
import Toggle from 'components/UI/Toggle';
import { usePerms } from 'contexts/PermsContext';
import { AuthContext } from 'features/Auth/contexts/AuthContext';
import { msalInitPromise } from 'features/Auth/contexts/utils/authUtils';
import Cookies from 'js-cookie';
import { useLocation, useNavigate } from 'react-router-dom';
import { _Environment } from 'services/_infra/environment';
import { login, loginWithCredentials, loginWithProvider } from 'services/auth/auth.service';
import { ms_syncAllUsers } from 'services/auth/ms.service';
import { submitFusionInquiry } from 'services/user/user.service';
import { clearCookies } from 'utils/cookieUtils';
import { getLogo } from 'utils/imageUtils';
import ContactUs from './ContactUs';

export default function Signin({
  setAuthenticated,
  widgetRefresh,
  termsAgreed,
  setTermsAgreed,
  privacyAgreed,
  setPrivacyAgreed,
  cookiesAgreed,
  setCookiesAgreed,
  policyVersion,
  termsVersion,
  setNewTermsFullyAgreed,
  newTermsFullyAgreed,
  termsDate,
  terms,
  termsFullyViewed,
  setTermsFullyViewed,
  hasSignedIn,
  setHasSignedIn,
  setShowFull,
  showFull,
}) {
  const navigate = useNavigate();
  const { login: authLogin } = useContext(AuthContext);
  const [email, setEmail] = useState(Cookies.get('email') || '');
  const [password, setPassword] = useState('');
  const perms = usePerms();

  const [display, setDisplay] = useState('login');
  const [rememberMe, setRememberMe] = useState(Cookies.get('rememberMe') === 'true');

  // ContactUs utils
  const [contactSubmitting, setContactSubmitting] = useState(false);
  const [contactError, setContactError] = useState(null);
  const isEmail = (s) => /\S+@\S+\.\S+/.test(String(s || '').trim());
  const hasMinDigits = (s, n = 7) => String(s || '').replace(/\D+/g, '').length >= n;

  //MICROSOFT LOGIN
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [apiData, setApiData] = useState(null);

  useEffect(() => {
    perms.reset();
  }, []);

  const theme = useContext(ColorContext);

  const [contactName, setContactName] = useState(null);
  const [contactEmail, setContactEmail] = useState(null);
  const [contactPhone, setContactPhone] = useState(null);
  const [contactSuccess, setContactSuccess] = useState(false);
  const [contactNotes, setContactNotes] = useState(null);
  const [signInProvider, setSignInProvider] = useState(null);
  const [microsoftButtonPressed, setMicrosoftButtonPressed] = useState(false);

  useEffect(() => {
    if (Cookies.get('rememberMe') === 'true') {
      setEmail(email);
      setRememberMe(true);

      if (Cookies.get('policyAgreed') === policyVersion) {
        setPrivacyAgreed(true);
        setCookiesAgreed(true);
      }
      if (Cookies.get('termsAgreed') === termsVersion) setTermsAgreed(true);
    } else {
      if (Cookies.get('rememberMe') === 'false') Cookies.remove('email');
      setEmail('');
      setPassword('');
      setRememberMe(false);
    }
  }, []);

  // const [isAccountActive, setIsAccountActive] = useState(false);
  const [signInError, setSignInError] = useState(null);
  const [msLoginTry, setMsLoginTry] = useState(false);

  const onMicrosoftSignIn = async () => {
    setMicrosoftButtonPressed(true);

    if (!instance) {
      setSignInError('Microsoft login is not configured');
      return;
    }

    try {
      // Wait for MSAL to be fully initialized (required in v3.x)
      await msalInitPromise;

      // Call loginRedirect with scopes
      await instance.loginRedirect({
        scopes: ['User.Read'],
      });

      setMsLoginTry(true);
    } catch (error) {
      console.error('[MSAL] loginRedirect failed:', error);
      setSignInError(error?.message || 'Microsoft login failed');
    }
  };

  const doNewSignIn = (provider) => {
    if (!provider && !(password && email)) {
      return;
    }
    setHasSignedIn(true);
    setSignInProvider(provider);
  };

  useEffect(() => {
    (async () => {
      if (!microsoftButtonPressed) {
        // return;
      }

      if (!account) {
        return;
      }

      const request = {
        scopes: ['User.Read'],
        account: account,
      };

      let msRes = null;
      if (account) {
        try {
          instance.setActiveAccount(account);
          msRes = await instance.acquireTokenSilent(request);
        } catch (err) {
          try {
            if (err instanceof InteractionRequiredAuthError) {
              msRes = await instance.acquireTokenPopup(request);
            }
          } catch (error) {
            console.error(error);
          }
        }
      }

      try {
        if (msRes) {
          Cookies.set('msToken', msRes.accessToken);

          // return
          if (
            Cookies.get('rememberMe') === 'true' ||
            Cookies.get('rememberMe') === true ||
            rememberMe === true
          ) {
            Cookies.set('rememberMe', rememberMe, { expires: 365 });

            Cookies.set('policyAgreed', policyVersion, { expires: 365 });
            Cookies.set('termsAgreed', termsVersion, { expires: 365 });
          } else {
            if (Cookies.get('rememberMe') === 'false') {
              Cookies.remove('email');
              Cookies.remove('rememberMe');
              Cookies.remove('policyAgreed');
              Cookies.remove('termsAgreed');
            }
          }
          loginWithProvider(
            termsAgreed && privacyAgreed && cookiesAgreed,
            termsVersion,
            policyVersion,
            {
              name: 'microsoft-azure',
              ...msRes,
            },
            instance,
          )
            .then((res) => {
              const { accessToken, refreshToken, userName, organization } = res.data;

              if (res.data.message === 'User authenticated') {
                // Use centralized login instead of setting cookies directly
                authLogin(accessToken, refreshToken);

                Cookies.set('email', email || res.data.email, { expires: 365 });
                Cookies.set('username', userName);
                Cookies.set('organizationName', organization);

                // setAuthenticated(true);
                setHasSignedIn(true);
                // setIsAccountActive(res.data.activated.status === "Active");
                moveToDashboard();
              }
            })
            .catch((err) => {
              setSignInError(err?.response?.data?.message || 'Login failed');
              if (err?.response?.data?.message === 'API DISABLED') {
                setSignInError('License disabled, contact RescAlert to restore access.');
              }
              setHasSignedIn(false);
              setTermsFullyViewed(false);
            });
        } else {
        }
      } catch (err) {}
    })();
    // }, [account, instance]);
  }, [msLoginTry, account, instance]);

  const moveToDashboard = () => {
    //change to switch if we implement more providers
    if (signInProvider === 'microsoft-azure') {
      (async () => {
        try {
          const res = await ms_syncAllUsers(instance);
          console.debug('[Signin] ms_syncAllUsers response', res?.data);
        } catch (err) {
          console.error('[Signin] ms_syncAllUsers error', err);
        }
      })();
    }

    setAuthenticated(true);
    navigate('/dashboard');
  };

  const onSignIn = () => {
    perms.reset();
    try {
      if (
        Cookies.get('rememberMe') === 'true' ||
        Cookies.get('rememberMe') === true ||
        rememberMe === true
      ) {
        Cookies.set('email', email, { expires: 365 });
        Cookies.set('rememberMe', rememberMe, { expires: 365 });

        Cookies.set('policyAgreed', policyVersion, { expires: 365 });
        Cookies.set('termsAgreed', termsVersion, { expires: 365 });
      } else {
        if (Cookies.get('rememberMe') === 'false') {
          Cookies.remove('email');
          Cookies.remove('rememberMe');
          Cookies.remove('policyAgreed');
          Cookies.remove('termsAgreed');
        }
      }
      loginWithCredentials(
        email,
        password,
        termsAgreed && privacyAgreed && cookiesAgreed,
        termsVersion,
        policyVersion,
      )
        .then((res) => {
          const { accessToken, refreshToken, userName, organization } = res.data;
          if (res.data.message === 'User authenticated') {
            // Use centralized login instead of setting cookies directly
            authLogin(accessToken, refreshToken);

            Cookies.set('email', email, { expires: 365 });
            Cookies.set('username', userName);
            Cookies.set('organizationName', organization);

            // setAuthenticated(true);
            // setIsAccountActive(res.data.activated.status === "Active");
            moveToDashboard();
          }
        })
        .catch((err) => {
          setSignInError(err?.response?.data?.message || 'Login failed');
          if (err?.response?.data?.message === 'API DISABLED') {
            setSignInError('License disabled, contact RescAlert to restore access.');
          }
          setHasSignedIn(false);
          setTermsFullyViewed(false);
        });
    } catch (err) {}
  };

  useEffect(() => {
    setTermsFullyViewed(false);
    setNewTermsFullyAgreed(false);
  }, []);

  const onContactUs = () => {
    if (!contactName || !contactEmail || !contactPhone) {
      return;
    }
    if (!isEmail(contactEmail)) {
      setContactError('Please enter a valid email.');
      return;
    }
    if (!hasMinDigits(contactPhone, 7)) {
      setContactError('Please enter a valid phone.');
      return;
    }

    setContactError(null);
    setContactSubmitting(true);

    try {
      submitFusionInquiry(
        contactName.trim(),
        contactEmail.trim(),
        contactPhone.trim(),
        contactNotes || '',
      );
      setContactSuccess(true);
      // reset fields
      setContactNotes('');
    } catch (err) {
      setContactError(err?.response?.data?.message || 'Failed to send. Please try again.');
    } finally {
      setContactSubmitting(false);
    }
  };

  const onRememberToggle = (val) => {
    setRememberMe(val);
    if (!val) {
      if (Cookies.get('rememberMe') === 'false') Cookies.remove('email');
    }
    // setRememberMe(!rememberMe);
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    // Check if the content height is less than or equal to the container height
    if (scrollHeight <= clientHeight) {
      setTermsFullyViewed(true);
    } else if (scrollTop + clientHeight >= scrollHeight) {
      setTermsFullyViewed(true);
    }
  };

  /////////////////////////////
  // Post Sign-In Terms Page //
  /////////////////////////////

  if (!newTermsFullyAgreed && hasSignedIn) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center p-2 position-relative text-center">
        <img
          src={getLogo(true)}
          alt="Logo"
          style={{
            position: 'absolute',
            top: 16,
            left: 16,
            maxWidth: 200,
            height: 'auto',
          }}
        />
        <h1>Terms of Use</h1>
        <p>This Terms of Use Policy was last modified on {termsDate}</p>
        <div
          className="overflow-auto d-flex mt-4 p-3 flex-column customScrollbar-Y"
          style={{
            background: theme.primaryShadow,
            whiteSpace: 'pre-wrap',
            minHeight: '250px',
            maxHeight: '30vi',
            width: '90%',
          }}
          onScroll={handleScroll}
        >
          <div className="html-content" dangerouslySetInnerHTML={{ __html: terms }}></div>
        </div>
        {!termsFullyViewed && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              gap: 20,
              marginTop: 20,
            }}
          >
            <input
              type="checkbox"
              value={termsFullyViewed}
              onChange={(e) => {
                setTermsFullyViewed(e.target.checked);
              }}
            />
            I have read the Terms of Use
          </div>
        )}
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <button
              style={{
                backgroundColor: theme.background,
                border: '1px solid white',
                color: theme.fontColor,
                padding: 10,
                margin: 10,
                marginLeft: 0,
                cursor: 'pointer',
              }}
              onClick={(e) => {
                e.stopPropagation();
                clearCookies();
                setNewTermsFullyAgreed(false);
                setTermsFullyViewed(false);
                setPrivacyAgreed(false);
                setCookiesAgreed(false);
                setHasSignedIn(false);
                setShowFull(true);
              }}
            >
              Decline
            </button>
            <button
              style={{
                backgroundColor: termsFullyViewed ? '#ffffff' : '#777777',
                border: '1px solid #0b1826',
                color: theme.fontColor,
                padding: 10,
                margin: 10,
                cursor: termsFullyViewed ? 'pointer' : 'not-allowed',
                color: theme.background,
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (privacyAgreed && cookiesAgreed) {
                  if (signInProvider === 'microsoft-azure') {
                    onMicrosoftSignIn();
                  } else {
                    onSignIn();
                  }
                } else {
                  alert('Please accept the Privacy & Cookie Policy');
                }
              }}
            >
              Accept Terms of Use
            </button>
          </div>
        </div>
      </div>
    );
  }

  ///////////////
  // Sign-In  //
  //////////////
  return (
    <div>
      <Container
        fluid
        className="vh-100 overflow-y-auto"
        style={{ margin: 0, padding: 0, position: 'fixed', inset: 0 }}
      >
        <div className="flex-box row g-0 h-100 position-relative z-4999">
          <div
            className="col-12 col-md-6 d-none d-md-block flex-grow-1 p-0"
            style={{
              backgroundImage: `url(${background})`,
              backgroundSize: 'cover',
              backgroundPosition: '60% 100%',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <div className="row g-0 h-100 align-items-end text-center">
              <div
                className="mb-5"
                style={{
                  WebkitTextStroke: '0.3px black',
                  color: theme.fontColor,
                }}
              >
                <div style={{ fontSize: 20 }}>Overwatch Fusion </div>
                <div style={{ fontSize: 36 }}>Powered by RescAlert Inc.</div>
              </div>
            </div>
          </div>

          <div
            className="col-12 col-md-6 d-flex flex-column align-items-center justify-content-around p-0"
            style={{ background: theme.background, color: theme.fontColor }}
          >
            {/* Logo */}
            <img
              className="p-3"
              src={getLogo(true)}
              style={{ width: '80%', maxWidth: 500, marginTop: '5%' }}
              alt="Logo"
            />

            {/* Form */}
            <div className="w-100 p-3" style={{ maxWidth: 380 }}>
              {display === 'login' ? (
                <>
                  <div className="mb-1">
                    <h1 className="mb-2">Nice to see you!</h1>
                    <div style={{ color: '#A0AEC0' }}>Enter your email and password to sign in</div>
                  </div>

                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (!newTermsFullyAgreed) {
                        doNewSignIn(null);
                        return;
                      }
                      if (privacyAgreed && cookiesAgreed) onSignIn();
                      else alert('Please accept the Privacy & Cookie Policy');
                    }}
                  >
                    <div className="mb-3">
                      <div className="py-1 mx-2">Email</div>
                      <CustomInput
                        value={email}
                        callback={setEmail}
                        type="text"
                        placeholder="Your email address"
                        autoComplete="email"
                      />
                    </div>

                    <div className="mb-3">
                      <div className="py-1 mx-2">Password</div>
                      <CustomInput
                        value={password}
                        callback={setPassword}
                        type="password"
                        placeholder="Your password"
                        autoComplete="current-password"
                      />
                    </div>

                    <div className="flex-row align-items-center">
                      <Toggle callback={onRememberToggle} value={rememberMe} />
                    </div>

                    {signInError && (
                      <div className="mt-2 text-danger" role="alert">
                        {signInError}
                      </div>
                    )}

                    {(!privacyAgreed || !cookiesAgreed) && (
                      <div className="mt-2 text-warning small" role="alert">
                        Please accept the Privacy & Cookie Policy below to sign in
                      </div>
                    )}

                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100 rounded-4 mt-5 mb-3 py-3"
                      disabled={!email || !password || !privacyAgreed || !cookiesAgreed}
                    >
                      SIGN IN
                    </Button>
                  </form>

                  <div className="text-center mt-3">
                    <a
                      href="/forgotpassword"
                      style={{
                        color: theme.fontColor,
                        textDecoration: 'none',
                        cursor: 'pointer',
                      }}
                    >
                      Forgot Password?
                    </a>
                  </div>

                  {/* MS sign-in stays only on login */}
                  <div className="text-center mt-4">
                    <div className="fs-5">Sign in with</div>
                    <div className="d-flex d-inline-flex w-50 align-items-center flex-nowrap">
                      <Button
                        variant="light"
                        className="flex-fill align-items-center gap-2 rounded-4 shadow-sm px-4 py-3 text-dark"
                        onClick={() => {
                          setSignInProvider('microsoft-azure');
                          if (!newTermsFullyAgreed) {
                            setHasSignedIn(true);
                            return;
                          }
                          if (privacyAgreed && cookiesAgreed) {
                            onMicrosoftSignIn();
                          } else {
                            setHasSignedIn(true);
                          }
                        }}
                        aria-label="Sign in with Microsoft"
                        disabled={inProgress !== 'none' || !privacyAgreed || !cookiesAgreed}
                      >
                        <img src={msLogo} alt="Microsoft" width={28} height={28} />
                        <span className="fw-medium text-nowrap">Microsoft</span>
                      </Button>
                    </div>
                  </div>
                  <div className="w-100 py-3 text-center">
                    <span style={{ color: '#A0AEC0' }}>Don't have an account? </span>
                    <button
                      type="button"
                      className="btn btn-link text-decoration-none px-0"
                      style={{ color: theme.fontColor, cursor: 'pointer' }}
                      onClick={() => setDisplay('contact')}
                    >
                      Contact Us
                    </button>
                  </div>
                </>
              ) : (
                <ContactUs
                  theme={theme}
                  contactName={contactName}
                  setContactName={setContactName}
                  contactEmail={contactEmail}
                  setContactEmail={setContactEmail}
                  contactPhone={contactPhone}
                  setContactPhone={setContactPhone}
                  contactNotes={contactNotes}
                  setContactNotes={setContactNotes}
                  success={contactSuccess}
                  error={contactError}
                  submitting={contactSubmitting}
                  onSubmit={onContactUs}
                  onBack={() => {
                    setContactSuccess(false);
                    setContactError(null);
                    setDisplay('login');
                  }}
                />
              )}
            </div>
            <footer className="w-100 text-center">
              <small>© 2023–{new Date().getFullYear()}, Powered by RescAlert Inc.</small>
              <div className="d-flex justify-content-center flex-wrap gap-4">
                <button
                  type="button"
                  className="btn btn-link text-decoration-none px-0"
                  style={{ color: theme.fontColor, opacity: 0.6 }}
                  onClick={() => {}}
                >
                  Marketplace
                </button>

                <button
                  type="button"
                  className="btn btn-link text-decoration-none px-0"
                  style={{ color: theme.fontColor, opacity: 0.6 }}
                  onClick={() => {}}
                >
                  Blog
                </button>

                <button
                  type="button"
                  className="btn btn-link text-decoration-none px-0"
                  style={{ color: theme.fontColor, opacity: 0.6 }}
                  onClick={() => {}}
                >
                  License
                </button>
              </div>
            </footer>
          </div>
        </div>
      </Container>
    </div>
  );
}
